<div class="order-ship-form--container lum-modal">
  <div class="lum-modal__header flex justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{ data.title }} </span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>

  <mat-dialog-content>
    <div class="order-ship-form--content mt-3 py-3">
      <ng-container *ngIf="shippableOrders.length > 0; else empty">
        <h6 class="shippable"> Shippable Orders ({{ shippableOrders.length }}) </h6>
        <table class="shippable table table-stripped">
          <thead>
            <tr>
              <th>Order Date</th>
              <th>Order ID</th>
              <th>Order #</th>
              <th class="text-right">Total</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of shippableOrders; trackBy: trackById">
              <td>{{ order.orderDate | date: 'mediumDate' }}</td>
              <td>{{ order.orderId }}</td>
              <td>{{ order.orderNumber }}</td>
              <td class="text-right">{{ order.orderTotal | currency: '' }}</td>
              <td>
                <span
                  class="shipping text-info"
                  *ngIf="order.shippingStatus === shippingStatus.SHIPPING"
                >
                  Shipping <i class="fas fa-spinner fa-spin"></i>
                </span>
                <span
                  class="shipping text-red-600"
                  *ngIf="order.shippingStatus === shippingStatus.FAILED"
                >
                  FAILED
                  <span *ngIf="order.shippingError">
                    [{{ order.shippingError }}]
                  </span>
                </span>
                <span
                  class="shipping text-green-700"
                  *ngIf="order.shippingStatus === shippingStatus.SHIPPED"
                >
                  SHIPPED
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
      <ng-template #empty>
        <div class="text-red-500">No orders can be shipped.</div>
      </ng-template>
    </div>
    <div class="order-ship-form--content mt-3 py-3">
      <ng-container *ngIf="nonShippableOrders.length > 0">
        <h6 class="non-shippable">These orders can't be shipped due to:</h6>
        <table class="non-shippable table table-stripped">
          <thead>
            <tr>
              <th style="width: 120px">Order Date</th>
              <th>Order ID</th>
              <th>Order #</th>
              <th class="text-right">Total</th>
              <th>Error(s)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of nonShippableOrders; trackBy: trackById">
              <td style="width: 120px">{{
                order.orderDate | date: 'mediumDate'
              }}</td>
              <td>{{ order.orderId }}</td>
              <td>{{ order.orderNumber }}</td>
              <td class="text-right">{{ order.orderTotal | currency: '' }}</td>
              <td class="non-shippable-error--message text-red-600">
                <span *ngIf="order.errors.missingBillingDetails">{{
                  orderShippingErrors.MISSING_BILLING_DETAILS
                }}</span>
                <span *ngIf="order.errors.missingShippingDetails">{{
                  orderShippingErrors.MISSING_SHIPPING_DETAILS
                }}</span>
                <span *ngIf="order.errors.isCancelledOrder">{{
                  orderShippingErrors.ORDER_CANCELLED
                }}</span>
                <span *ngIf="order.errors.hasShipstationOrderId">{{
                  orderShippingErrors.SHIPSTATION_EXISTS
                }}</span>
                <span *ngIf="order.errors.isTransferOrder">{{
                  orderShippingErrors.IS_TRANSFER_ORDER
                }}</span>
                <span *ngIf="order.errors.isShipstation">{{
                  orderShippingErrors.IS_SHIPSTATION
                }}</span>
                <span *ngIf="order.errors.isPosted">{{
                  orderShippingErrors.NOT_POSTED
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      type="button"
      class="lum-button lum-button--tertiary mr-2"
      mat-button
      (click)="onClose()"
    >
      Close
    </button>
    <button
      (click)="onConfirmShipOrders()"
      [disabled]="disableConfirmShipOrders"
      mat-button
      type="button"
      class="lum-button"
    >
      Confirm and Ship Orders
    </button>
  </mat-dialog-actions>
</div>
